// routes
import { useAtom } from "jotai";
import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./components/ScrollToTop";
import { AppConstants, StorageConstants } from "./constants/AppConstants";
import {
  KOTPrinterConfiguration,
  printerConfiguration,
  printerOrderIdPrefixState,
  remoteUrlState,
  responsive,
} from "./global/jotaiState";
import { generateUniquieId } from "./helper/generateUniqueId";
import ObjectStorage from "./modules/ObjectStorage";
import Router from "./routes";
import AuthService from "./services/authService";

import { isEmpty } from "lodash";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "react-simple-keyboard/build/css/index.css";
import Logout from "./components/Logout";

function App() {
  const deviceId = AuthService.getDeviceId();
  const setWindowSize = useAtom(responsive)[1];
  const setPrinterConfiguration = useAtom(printerConfiguration)[1];
  const setKOTPrinterConfiguration = useAtom(KOTPrinterConfiguration)[1];
  const setOrderIdPrefix = useAtom(printerOrderIdPrefixState)[1];
  const setRemoteUrl = useAtom(remoteUrlState)[1];

  useEffect(() => {
    const { data: previousPrefix } = ObjectStorage.getItem(
      StorageConstants.ORDER_ID_PREFIX
    );

    const previousPrinterData = ObjectStorage.getItem(
      StorageConstants.PRINTER_VID_PID
    );
    const previousKOTPrinterData = ObjectStorage.getItem(
      StorageConstants.KOT_PRINTER_CONFIG
    );
    if (previousPrefix && !isEmpty(previousPrefix)) {
      setOrderIdPrefix(previousPrefix);
    }
    if (!isEmpty(previousPrinterData)) {
      setPrinterConfiguration(previousPrinterData);
    }
    if (!isEmpty(previousKOTPrinterData)) {
      setKOTPrinterConfiguration(previousKOTPrinterData);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    if (!deviceId)
      ObjectStorage.setItem(StorageConstants.DEVICE_UNIQUE_ID, {
        id: generateUniquieId(),
      });

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const { data: remoteUrl } = ObjectStorage.getItem(
      StorageConstants.REMOTE_URL
    );
    setRemoteUrl(remoteUrl || AppConstants.DEFAULT_REMOTE_URL);

    if (!remoteUrl) {
      ObjectStorage.setItem(StorageConstants.REMOTE_URL, {
        data: AppConstants.DEFAULT_REMOTE_URL,
      });
    }
  }, []);

  return (
    <>
      <Toaster />
      <ScrollToTop />
      <Router />
      <Logout />
    </>
  );
}

export default App;
